const STORAGE_KEY = 'groversweets_bill_to_flow_tools';

export const TOOL_TYPE_LABELS = {
  sweet_category: 'Sweet Category',
  restaurant_item: 'Restaurant Item',
  rm_pm: 'RM / PM',
};

export function loadMyTools() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const list = raw ? JSON.parse(raw) : [];
    return Array.isArray(list) ? list : [];
  } catch {
    return [];
  }
}

export function saveMyTool(tool) {
  const list = loadMyTools();
  const next = [tool, ...list.filter((item) => String(item?.id) !== String(tool?.id))];
  localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  return next;
}

export function formatToolCreatedAt(value) {
  if (!value) return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  });
}
